<template>
  <div
    :class="{
      'sign-plan--readonly-panel': readonlyPanel,
      'sign-plan--disabled': disabled,
    }"
  >
    <validation-observer ref="signPlanFormRef">
      <validation-provider v-slot="{ errors }" rules="validOption">
        <div
          class="d-flex flex-column align-items-start border-bottom"
          :class="{
            'flex-md-row align-items-md-center': !readonlyPanel,
            'sign-plan__question-row--readonly': readonlyPanel,
          }"
        >
          <div class="flex-grow-1">
            {{ questionLabel }}
            <custom-error
              v-if="errors[0]"
              class="ml-n1"
              message="Favor de seleccionar una opción."
              variant="no-border"
            />
          </div>
          <custom-radio
            ref="question"
            v-model="questionAnswer"
            :change-event="handleChangeEventOption"
            class="custom-radio__extended mt-3 mt-md-0"
            container-class="custom-radio-center"
            custom-error-msg="''"
            :disabled="disabled"
            is-question-list
            name="question-1"
            :options="mechanismOptions"
          />
        </div>
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import CustomRadio from 'custom-radio';
import CustomError from 'custom-error';

extend('validOption', {
  validate(value) {
    return [true, false].includes(value);
  },
  message: 'Favor de seleccionar una opción válida.',
});

export default {
  name: 'SignPlan',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomRadio,
    CustomError,
  },
  props: {
    isElectronicSignature: {
      type: Boolean,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    questionLabel: {
      type: String,
      default:
        '¿Cuál será el mecanismo que se estará utilizando para firmar el Plan de Intervención?',
    },
    readonlyPanel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      questionAnswer: null,
      mechanismOptions: [
        {
          name: 'answer1',
          label: 'Electrónica',
          value: true,
          check: false,
        },
        {
          name: 'answer2',
          label: 'Manuscrito',
          value: false,
          check: false,
        },
      ],
    };
  },
  computed: {},
  watch: {
    isElectronicSignature: {
      handler(val) {
        this.setSelectedQuestion(val);
      },
    },
  },
  mounted() {
    this.setSelectedQuestion(this.isElectronicSignature);
  },
  methods: {
    async validate() {
      return await this.$refs.signPlanFormRef.validate();
    },
    handleChangeEventOption(value) {
      const selectedValue = value ? value.value : null;
      if (selectedValue !== this.isElectronicSignature) {
        this.questionAnswer = selectedValue;
        this.$emit('update:isElectronicSignature', selectedValue);
        this.$emit('change', value);
      }
    },
    setSelectedQuestion(val) {
      this.mechanismOptions.forEach((element) => {
        element.check = false;
      });

      var itemIndex = this.mechanismOptions.findIndex((x) => x.value == val);

      if (itemIndex === -1) {
        this.questionAnswer = null;
        return;
      }

      var item = this.mechanismOptions[itemIndex];
      item.check = true;
      this.mechanismOptions[itemIndex] = item;
      this.questionAnswer = item.value;
    },
  },
};
</script>

<style scoped lang="scss">
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';
::v-deep .custom-radio__extended {
  .custom-radio-container {
    .custom-radio-button {
      border: unset;
      background: map.get($colors, 'secondary-9') !important;
      width: 120px !important;
      height: 70px !important;
      flex-shrink: 0 !important;
      .radio {
        margin-top: 10px;
      }
      .step-label {
        font-size: 12px;
        color: map.get($colors, 'gray-8');
      }
    }
    .custom-radio-button.bg-checked {
      .rounded-circle {
        border-color: map.get($colors, 'white');
        i {
          color: map.get($colors, 'white');
          top: -5px;
        }
      }
    }

    .custom-radio-button.bg-green {
      background: map.get($colors, 'secondary-22') !important;
      .step-label {
        color: map.get($colors, 'white') !important;
      }
    }
  }
}

.sign-plan--disabled:not(.sign-plan--readonly-panel)
  ::v-deep
  .custom-radio-container
  .custom-radio-button.bg-green {
  background: #294348 !important;
}

.sign-plan--readonly-panel {
  .sign-plan__question-row--readonly {
    flex-direction: column !important;
    align-items: flex-start !important;
    padding-bottom: 12px;
  }

  .flex-grow-1 {
    width: 100%;
  }
}

.sign-plan--readonly-panel ::v-deep .custom-radio__extended {
  width: 100%;
  margin-top: 8px !important;
  margin-bottom: 0 !important;
}

.sign-plan--readonly-panel ::v-deep .custom-radio-container {
  width: 100%;
  gap: 8px;
  align-items: stretch !important;
}

.sign-plan--readonly-panel ::v-deep .custom-radio-container > div {
  flex: 1 1 0;
}

.sign-plan--readonly-panel
  ::v-deep
  .custom-radio-container
  .custom-radio-button {
  width: 100% !important;
  height: 48px !important;
  border: 0 !important;
  border-radius: 2px 2px 0 0 !important;
  background: map.get($colors, 'secondary-9') !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: default !important;
}

.sign-plan--readonly-panel
  ::v-deep
  .custom-radio-container
  .custom-radio-button
  .radio {
  margin-top: 0 !important;
  line-height: 1;
}

.sign-plan--readonly-panel
  ::v-deep
  .custom-radio-container
  .custom-radio-button
  label {
  line-height: 1;
}

.sign-plan--readonly-panel
  ::v-deep
  .custom-radio-container
  .custom-radio-button
  .rounded-circle {
  width: 14px;
  height: 14px;
  border-color: #b5c3bc;
  margin-bottom: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.sign-plan--readonly-panel
  ::v-deep
  .custom-radio-container
  .custom-radio-button
  .rounded-circle
  i {
  color: map.get($colors, 'white') !important;
  font-size: 9px;
  line-height: 1;
  position: static;
}

.sign-plan--readonly-panel
  ::v-deep
  .custom-radio-container
  .custom-radio-button
  .step-label {
  color: #b5c3bc !important;
  font-size: 10px !important;
  line-height: 1;
}

.sign-plan--readonly-panel
  ::v-deep
  .custom-radio-container
  .custom-radio-button.bg-green {
  background: #294348 !important;
}

.sign-plan--readonly-panel
  ::v-deep
  .custom-radio-container
  .custom-radio-button.bg-green
  .rounded-circle {
  border-color: map.get($colors, 'white');
}

.sign-plan--readonly-panel
  ::v-deep
  .custom-radio-container
  .custom-radio-button.bg-green
  .step-label {
  color: map.get($colors, 'white') !important;
}
</style>
